// Locale strings of report 2.7 (accounts-inventory), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "Accounts Inventory",
  title: "Accounts Inventory",
  reportDate: "Inventory date",
  yearStart: "Fiscal year start",
  sector: "Sector",
  allSectors: "All sectors",
  customParent: "Custom parent account",
  customParentLabel: "Parent account",
  subsector: "Subsector",
  allSubsectors: "All subsectors",
  status: "Account status",
  allStatuses: "All statuses",
  balanceFilter: "Balance",
  balanceAll: "All balances",
  balancePositive: "Positive balance",
  balanceNegative: "Negative balance",
  balanceZero: "Zero balance",
  balanceAbnormal: "Abnormal balance",
  balanceRange: "Range",
  balanceFrom: "Balance from",
  balanceTo: "Balance to",
  lastFrom: "Last movement from",
  lastTo: "Last movement to",
  daysFrom: "Days from",
  daysTo: "Days to",
  notMovedDays: "Not moved for (days)",
  partyType: "Party type",
  allPartyTypes: "All parties",
  noParty: "No party",
  partySearch: "Party name / phone",
  province: "Governorate",
  allProvinces: "All governorates",
  partyStatus: "Party status",
  allPartyStatuses: "All statuses",
  advanced: "Classification thresholds",
  activeDays: "Active up to (days)",
  semiDays: "Semi-active up to (days)",
  dormantDays: "Dormant up to (days)",
  largeBalance: "Large balance limit",
  thresholdsHint: "Active <= 30, semi-active 31-60, dormant 61-90, very dormant > 90 (defaults)",
  viewDetailed: "Detailed table",
  viewSummary: "Sector summary",
  viewAlerts: "Alerts",
  viewDeleted: "Deleted parties",
  accountsCount: "Accounts",
  totalAccounts: "Accounts",
  active: "Active",
  semiActive: "Semi-active",
  dormant: "Dormant",
  veryDormant: "Very dormant",
  unused: "Unused",
  closed: "Closed",
  zeroBalance: "Zero balance",
  debitBalances: "Total debit balances",
  creditBalances: "Total credit balances",
  net: "Net balance",
  abnormal: "Abnormal balances",
  needsReview: "Need review",
  closable: "Can be closed",
  colIndex: "#",
  colCode: "Account code",
  colName: "Account name",
  colLevel: "Level",
  colParentCode: "Parent code",
  colParentName: "Parent name",
  colType: "Account type",
  colNature: "Normal balance",
  colIsActive: "Active",
  colIsLeaf: "Leaf",
  colPartyId: "Party id",
  colParty: "Party",
  colPartyType: "Party type",
  colPartyPhone: "Phone",
  colPartyStatus: "Party status",
  colPartyCreatedAt: "Party created at",
  colLastDate: "Last movement",
  colLastType: "Last movement side",
  colLastAmount: "Last movement amount",
  colLastJournal: "Last entry id",
  colLastReference: "Last reference",
  colDays: "Days",
  colMovements: "Movements",
  colTotalDebit: "Total debit",
  colTotalCredit: "Total credit",
  colOpening: "Opening balance",
  colBalance: "Balance",
  colBalanceType: "Balance side",
  colBalanceAge: "Balance age (days)",
  colAbnormal: "Abnormal balance",
  colStatus: "Account status",
  colZeroBalance: "Zero balance",
  colDormant: "Dormant",
  colDormancyReason: "Dormancy reason",
  colNeedsReview: "Needs review",
  colAction: "Recommended action",
  colAgeFlag: "Age class",
  colSector: "Sector",
  colSubsector: "Subsector",
  colProvince: "Governorate",
  colGroup: "Group",
  colAccountCreatedAt: "Account created at",
  colAlert: "Alert",
  colCondition: "Condition",
  colAlertAction: "Action",
  colValue: "Value",
  yes: "Yes",
  no: "No",
  details: "Details",
  noAlerts: "No alerts",
  noDeleted: "No accounts of deleted parties",
  deletedNote: "Accounts of deleted parties are excluded from the detailed table and the summary.",
  truncated: "More than 10,000 accounts - please narrow the filters",
  sheetHeader: "Header",
  sheetDetailed: "Detailed",
  sheetSummary: "Summary",
  sheetAlerts: "Alerts",
  headerSector: "Sector",
  headerSubsector: "Subsector",
  headerAccounts: "Accounts",
  headerYearStart: "Fiscal year start",
  headerThresholds: "Thresholds (days)",
  headerWarnings: "Warnings",
  headerNotes: "Notes",
  field: "Item",
  value: "Value",
  printSummary: "Report summary by sector",
  printDetailed: "Detailed table",
  printAlerts: "Alerts",
  rangeNeedsBounds: "Enter both balance bounds for the range",
  statusLabels: {
    active: "Active",
    semi_active: "Semi-active",
    dormant: "Dormant",
    very_dormant: "Very dormant",
    unused: "Unused",
    closed: "Closed",
    zero_balance: "Zero balance",
  },
  actionLabels: {
    correct_balance: "Correct the balance",
    close: "Close the account",
    urgent_review: "Urgent review",
    alert: "Alert",
    normal: "Routine follow-up",
    none: "No action",
  },
  partyTypeLabels: {
    captain: "Driver",
    center: "Charge centre",
    business: "Business",
    owner: "Car owner",
    employee: "Employee",
  },
  partyStatusLabels: {
    active: "Active",
    suspended: "Suspended",
    deleted: "Deleted",
  },
  sideLabels: {
    debit: "Debit",
    credit: "Credit",
    balanced: "Balanced",
  },
  ageFlags: {
    new: "New",
    dead: "Dead",
  },
};
